<script setup>

    import { ref, computed, inject, nextTick } from "vue";
    import ChatbotQuestion           from "./ChatbotQuestion.vue";
    import ChatbotLink               from "./ChatbotLink.vue";

    let isOpen = ref(false);
    let isNeverOpen = ref(true);
    let showLink = ref(false);
    let linkAnswer = ref({});


    let strOpenClass = computed ( () => isOpen.value ? "open" : "");
    function toggleChatbot ()
    {
        isOpen.value = !isOpen.value;
        isNeverOpen.value = false;
    }

    function reset ()
    {
        showLink.value = false;
        questions.value = [];

        answers.value = [];

        nextTick( () => questions.value = [chatbot[0]]); //wait one tick to reset the questions
    }

    function onAnswer (answer)
    {
/*console.log(("onAnswer", answer))*/;        answers.value.push(answer);

        if (answer.has_followup_question)
        {
            let nextQuestion = chatbot.find( q => q.id === answer.id_next_question)
            questions.value.push(nextQuestion);
        }
        else
        {
            linkAnswer.value = answer?.value?.data?.url ?? answer?.data?.url ?? ""
            showLink.value = true;

            onScrollToBottom();

        }
    }

    function onScrollToBottom ()
    {
        let scrollable = document.querySelector(".chatbot-conversation"); //ref was not working for some reason

        if (scrollable)
        {
            nextTick( () => {

                let options = {
                    top : scrollable.scrollHeight ?? 0,
                }

                scrollable.scroll( options )
            });

            //setTimeout ( () => console.log("scrollHeight", refChatbot?.value?.scrollHeight ?? 0), 1000);
        }
    }

    let chatbot = inject("chatbot");
    let copydeck = inject('copydeck');
    let answers = ref ([]);

    let questions = ref( [chatbot[0]] );
    let refChatbot = ref(null);

/*console.log(("App", questions))*/;
</script>

<template>
    <aside class="chatbot" >

        <div class="chatbot-body" :class="strOpenClass" style="" id="chatbot-body" aria-hidden="true" tabindex="-1">
            <div class="chatbot-header">
                <div class="d-flex justify-content-between align-items-center">
                    <button class="chatbot-back-btn" @click="reset"><i class="fa-regular fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Réinitialiser le chatbot</span></button>
                    <h3> {{ copydeck?.chatbot?.nom?.fr ?? 'Amélio' }}</h3>
                    <button class="chatbot-close-btn" @click="toggleChatbot"><i class="fa-regular fa-xmark" aria-hidden="true"></i><span class="sr-only">Fermer le chatbot</span></button>
                </div>
            </div>
    <div class="chatbot-conversation-wrapper" v-if="!isNeverOpen" v-show="isOpen">
                <div class="chatbot-conversation" aria-live="polite" role="dialog" ref="refChatbot">

                    <chatbot-question

                        v-for="(question,index) in questions"
                        :question="question"
                        :index="index"
                        :key="question.id"
                        @onAnswer="onAnswer"
                        @onScrollToBottom="onScrollToBottom"/>


                    <chatbot-link
                        v-if="showLink"
                        :answer="linkAnswer"
                        :title="copydeck?.chatbot?.title_lien?.fr ?? 'Voilà!'"
                        @onScrollToBottom="onScrollToBottom" />

                    <div class="d-flex d-none" id="chatbot_thinking">
                        <div class="chatbot-avatar"></div>
                        <div class="response bot anim"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end chatbot-toggle-container">
            <button class="chatbot-open-btn" aria-controls="chatbot-body"  @click="toggleChatbot" aria-expanded="false"><span class="sr-only">Ouvrir le chatbot</span></button>
        </div>
    </aside>
</template>

<style scoped>

</style>
